// Batch 5: User Specific Missing Areas (Story-driven, localized Egyptian context)
export const areaContentBatch5 = {
  "التجمع التالت": {
    tier: 2,
    title: "ونش انقاذ التجمع التالت",
    metaDescription: "ونش انقاذ التجمع التالت: بنوفرلك إنقاذ سريع عند الجامعة الألمانية، فيوتشر مول، ومحور جمال عبد الناصر. وصول في 10 دقايق، خدمة 24 ساعة بأسعار واضحة بدون استغلال - 01044844492.",
    intro: "التجمع التالت من المناطق الحيوية اللي مليانة حركة شبابية وطلاب عشان الجامعة الألمانية، وده بيخلي الأعطال المفاجئة واردة جداً سواء الصبح بدري وقت المحاضرات أو بليل. احنا متمركزين باستمرار عند ميدان أرابيلا ومحور جمال عبد الناصر عشان نضمن إن لو عربيتك عطلت، مش هتستنى أكتر من 10 دقايق في الشارع.",
    responseTime: "10-15 دقيقة في التجمع التالت",
    landmarks: ["الجامعة الألمانية GUC", "فيوتشر مول", "ميدان أرابيلا", "نادي الجمارك", "إسكان الشباب"],
    streets: ["محور جمال عبد الناصر", "شارع الشباب", "طريق القطامية القديم", "شارع النرجس"],
    localNotes: [
      "لو عطلت قدام الـ GUC أو في شوارع إسكان الشباب الضيقة، أوناشنا بتعرف تتحرك بسهولة وتسحب عربيتك بدون زحمة.",
      "بنوفر خدمة شحن البطارية السريعة للطلبة اللي بينسوا نور العربية شغال طول اليوم."
    ],
    nearby: ["التجمع الخامس", "القطامية", "شارع التسعين", "الهضبة الوسطى"],
    faqs: [
      {
        "q": "عربيتي عطلت جوه شوارع إسكان الشباب الضيقة، الونش هيعرف يدخل؟",
        "a": "أكيد، أوناشنا مجهزة بحجم مناسب عشان تدخل أضيق الشوارع السكنية وتسحب العربية بأمان تام بدون أي خدش."
      },
      {
        "q": "بتقدموا خدمات تانية غير السحب في التجمع التالت؟",
        "a": "بجانب السحب، بنقدم كابل شحن للبطارية، تزويد بنزين، وتغيير كاوتش لو مشكلتك بسيطة ومش محتاجة نقل."
      }
    ]
  },

  "الحي التامن": {
    tier: 2,
    title: "ونش انقاذ الحي التامن مدينة نصر",
    metaDescription: "عطلان في الحي التامن بمدينة نصر؟ ونش انقاذ محمد بحر معاك في دقايق حوالين السراج مول ومكرم عبيد. خدمة 24/7 سريعة ومضمونة لإنقاذ عربيتك - اتصل 01044844492.",
    intro: "الحي التامن في مدينة نصر بيعتبر من أكتر الأحياء كثافة، سواء زحمة السراج مول أو الشوارع المتفرعة من مكرم عبيد ومصطفى النحاس. لو عربيتك سخنت في الزحمة أو الكاوتش نام منك، ونش إنقاذ محمد بحر متواجد في محيط الحي التامن عشان يسحبك بسرعة قبل ما المرور يقف، وبنوصلك لأقرب مركز صيانة في مدينة نصر أو الحرفيين.",
    responseTime: "10-12 دقيقة في محيط الحي التامن",
    landmarks: ["السراج مول", "حديقة الطفل", "مدارس المنهل", "النادي الأهلي مدينة نصر"],
    streets: ["شارع مصطفى النحاس", "شارع مكرم عبيد", "شارع حسن المأمون", "شارع أبو داود الظاهري"],
    localNotes: [
      "بنتعامل بحرص شديد مع العربيات اللي بتعطل في مناطق الزحام زي قدام السراج مول عشان منعملش تكدس مروري.",
      "فريقنا حافظ شوارع الحي التامن زي اسمه، وبنوصلك من أسرع طريق حتى في أوقات الذروة وخروج المدارس."
    ],
    nearby: ["مكرم عبيد", "مصطفى النحاس", "عباس العقاد", "الحي السابع", "الحي العاشر"],
    faqs: [
      {
        "q": "لو العربية عطلت في جراج السراج مول، تقدروا تطلعوها؟",
        "a": "أيوة، عندنا أوناش إنقاذ (شوكة) مخصصة للجراجات المنخفضة واللي مساحتها ضيقة، بنسحبها ونطلعها للشارع بأمان."
      }
    ]
  },

  "ميدان الجامع": {
    tier: 2,
    title: "ونش انقاذ ميدان الجامع مصر الجديدة",
    metaDescription: "ونش انقاذ ميدان الجامع بمصر الجديدة، أسرع استجابة في قلب الزحمة. بنوصلك في 10 دقايق لإنقاذ عربيتك بخصم 50% وأمان تام - 01044844492.",
    intro: "ميدان الجامع في مصر الجديدة من أشهر وأعرق الميادين، لكن زحمته وقت التسوق ممكن تخلي عطل العربية كابوس. ماتقلقش، احنا متواجدين في قلب مصر الجديدة وقريبين جداً من ميدان الجامع وروكسي. بمجرد ما تكلمنا، بنوجه أقرب ونش ليك يتعامل مع الموقف بهدوء واحترافية ويسحب عربيتك بدون ما يسبب قلق في الشارع.",
    responseTime: "10 دقائق في مصر الجديدة",
    landmarks: ["ميدان الجامع", "مسجد جمال الدين الأفغاني", "سوق ميدان الجامع", "سينما روكسي"],
    streets: ["شارع هارون الرشيد", "شارع الأهرام", "شارع أبو بكر الصديق", "شارع دمشق"],
    localNotes: [
      "عارفين إن الحركة في ميدان الجامع بطيئة، عشان كده بنستخدم دراجات نارية للتقييم السريع أحياناً قبل وصول الونش لتأمين العربية.",
      "خبرة في التعامل مع العربيات الكلاسيكية والقديمة اللي بتعطل كتير في مناطق مصر الجديدة العريقة."
    ],
    nearby: ["روكسي", "مصر الجديدة", "تريومف", "الكوربة", "سفير"],
    faqs: [
      {
        "q": "الشارع زحمة جداً في ميدان الجامع، الونش هيعرف يقف يحمل العربية؟",
        "a": "فريقنا مدرب على سرعة التحميل والإنجاز في الشوارع المزدحمة بأقل إعاقة مرورية ممكنة وبأعلى درجات الأمان."
      }
    ]
  },

  "سفير": {
    tier: 2,
    title: "ونش انقاذ ميدان سفير",
    metaDescription: "أقرب ونش انقاذ في ميدان سفير بمصر الجديدة. بنوفرلك نقل آمن وسريع لعربيتك المعطلة 24 ساعة بأسعار واضحة بدون استغلال - اتصل 01044844492.",
    intro: "ميدان سفير نقطة ربط مهمة جداً في مصر الجديدة بين الكلية الحربية وميدان تريومف. لو عربيتك قطعت بنزين أو حصل مشكلة في الفتيس وإنت معدي من سفير، مش هنسيبك تعطل كتير. أوناشنا متمركزة على محور عمار بن ياسر وأبو بكر الصديق عشان نضمن وصول فوري لأي طارئ في محيط ميدان سفير.",
    responseTime: "10-15 دقيقة في محيط سفير",
    landmarks: ["ميدان سفير", "الكلية الحربية (بالقرب)", "نادي الجلاء", "مستشفى هليوبوليس"],
    streets: ["شارع عمار بن ياسر", "شارع أبو بكر الصديق", "شارع النزهة", "شارع الحجاز"],
    localNotes: [
      "سرعة استجابة استثنائية على طول شارع أبو بكر الصديق وعمار بن ياسر.",
      "خدمة إنقاذ السيارات الفخمة المنتشرة في هذه المنطقة بأوناش هيدروليكية كاملة (فلات بيد) لضمان زيرو خدوش."
    ],
    nearby: ["تريومف", "ميدان الحجاز", "مصر الجديدة", "الماظة"],
    faqs: [
      {
        "q": "عربيتي واطية جداً (سبورت)، هل سحبها آمن؟",
        "a": "بكل تأكيد، بنستخدم أوناش فلات بيد (سطحة) زاوية ميلها مصممة خصيصاً للعربيات الرياضية المنخفضة لحماية الإكصدامات."
      }
    ]
  },

  "ميدان الحجاز": {
    tier: 2,
    title: "ونش انقاذ ميدان الحجاز",
    metaDescription: "محتاج ونش انقاذ في ميدان الحجاز؟ احنا جنبك! وصول سريع، أمان تام للعربية، وخدمة 24/7 في قلب مصر الجديدة. اتصل بونش محمد بحر - 01044844492.",
    intro: "ميدان الحجاز وشارع الحجاز من المحاور الطويلة والأساسية في مصر الجديدة. تخيل عربيتك تعطل وإنت رايح شغلك الصبح أو راجع بالليل تعبان! احنا حاسين بيك، وعشان كده موفرين أوناش إنقاذ متواجدة بشكل دائم في محيط ميدان الحجاز ومستشفى النزهة الدولي لإنقاذك في أسرع وقت وبأسعار في المتناول.",
    responseTime: "10 دقائق في محيط الحجاز",
    landmarks: ["ميدان الحجاز", "مستشفى النزهة الدولي", "نادي الشمس", "ميدان هليوبوليس"],
    streets: ["شارع الحجاز", "شارع عبد الحميد بدوي", "شارع عمار بن ياسر"],
    localNotes: [
      "تغطية سريعة للحوادث لا قدر الله على تقاطعات شارع الحجاز.",
      "توفير خدمة السحب لأقرب توكيل صيانة في مصر الجديدة أو جسر السويس."
    ],
    nearby: ["سفير", "مصر الجديدة", "النزهة", "جسر السويس"],
    faqs: [
      {
        "q": "اقدر ادفع بالفيزا بعد ما الونش يوصلني؟",
        "a": "بنوفر طرق دفع متعددة، كاش أو إنستاباي أو محافظ إلكترونية زي فودافون كاش لسهولة التعامل."
      }
    ]
  },

  "التل الكبير": {
    tier: 2,
    title: "ونش انقاذ التل الكبير",
    metaDescription: "ونش انقاذ التل الكبير والقصاصين وطريق الإسماعيلية الزراعي ووادي الملاك. إنقاذ سريع وسحب سيارات 24 ساعة بخصم 50% - 01044844492.",
    intro: "التل الكبير نقطة ارتكاز حيوية على طريق الإسماعيلية الزراعي وتربط بين محافظة الشرقية ومدن القناة. أوناش ونش إنقاذ محمد بحر متمركزة في محيط التل الكبير والقصاصين لتوفير نجدة فورية لسيارات الملاكي والنقل الخفيف، والتعامل الاحترافي مع أعطال الطرق الزراعية والسريعة على مدار 24 ساعة.",
    responseTime: "20-30 دقيقة في محيط التل الكبير والطرق الزراعية",
    landmarks: [
      "مدينة التل الكبير وميدان المحطة",
      "محطة قطار التل الكبير",
      "كوبري التل الكبير",
      "مستشفى التل الكبير المركزي",
      "القصاصين الجديدة",
      "وادي الملاك",
      "حدود محافظة الشرقية والإسماعيلية"
    ],
    streets: [
      "طريق الإسماعيلية الزراعي",
      "طريق الزقازيق - التل الكبير",
      "طريق القصاصين",
      "شارع المحطة الرئيسي",
      "طريق وادي الملاك",
      "طريق التل الكبير - أبو حماد"
    ],
    localNotes: [
      "تمركز استراتيجي على طريق الإسماعيلية الزراعي لضمان سرعة الوصول للسيارات المعطلة والحوادث.",
      "معدات سحب هيدروليكية متطورة مجهزة للتعامل مع المنحدرات والطرق الترابية الزراعية بأمان كامل.",
      "إمكانية نقل وسحب السيارات لمراكز الصيانة والورش المعتمدة في الإسماعيلية أو الزقازيق أو القاهرة بخصم 50%."
    ],
    nearby: ["أبو حماد", "الزقازيق", "الشرقية", "الإسماعيلية", "طريق الإسماعيلية"],
    faqs: [
      {
        "q": "كم يستغرق وصول ونش الإنقاذ في التل الكبير وطريق الإسماعيلية الزراعي؟",
        "a": "يصل الونش خلال 20-30 دقيقة حسب موقعك على الطريق الزراعي أو داخل أحياء وقرى التل الكبير."
      },
      {
        "q": "هل تغطون منطقة وادي الملاك والقصاصين التابعة للتل الكبير؟",
        "a": "نعم، التغطية تشمل وادي الملاك، القصاصين، والقرى المجاورة على مدار 24 ساعة دون انقطاع."
      },
      {
        "q": "عربيتي نزلت في طريق زراعي غير ممهد، تقدروا تطلعوها؟",
        "a": "نعم، أوناشنا مزودة بوايرات سحب هيدروليكية مخصصة لإخراج السيارات من المنحدرات والطرق الترابية بأمان تام دون أي ضرر للشاسيه."
      }
    ]
  },

  "أبو حماد": {
    tier: 2,
    title: "ونش انقاذ أبو حماد",
    metaDescription: "ونش انقاذ أبو حماد وطريق الزقازيق الإسماعيلية الزراعي وبحر مويس. إنقاذ سريع وسحب سيارات 24 ساعة بخصم 50% - اتصل 01044844492.",
    intro: "مركز ومدينة أبو حماد بمحافظة الشرقية نقطة ارتكاز حيوية على طريق الزقازيق - الإسماعيلية الزراعي. أوناشنا متمركزة لخدمة أهالي أبو حماد والمسافرين على الطرق الزراعية والسريعة بالشرقية، لنقل وسحب السيارات المعطلة والحوادث بأقصى سرعة وأعلى درجات الأمان.",
    responseTime: "15–25 دقيقة في أبو حماد والقرى التابعة",
    landmarks: [
      "ميدان المحطة ومحطة قطار أبو حماد",
      "كوبري أبو حماد العلوي الجديد",
      "مستشفى أبو حماد المركزي",
      "قرية كفر العزازي",
      "العباسة (مركز البحوث والمزارع السمكية)",
      "طريق بحر مويس",
      "مدخل قرية الصوة والسعدية"
    ],
    streets: [
      "طريق الزقازيق - أبو حماد الزراعي",
      "طريق الإسماعيلية الزراعي",
      "شارع بورسعيد (أبو حماد)",
      "طريق بحر مويس",
      "طريق أبو حماد - بلبيس",
      "شارع الجيش بأبو حماد"
    ],
    localNotes: [
      "تمركز دائم بالقرب من كوبري أبو حماد الجديد لتغطية سريعة للطريق الزراعي في اتجاه الزقازيق أو التل الكبير والإسماعيلية.",
      "أوناش سطحة هيدروليكية مجهزة للتعامل مع المنحدرات الترابية وضفاف بحر مويس وسحب السيارات العالقة بأمان.",
      "إمكانية نقل السيارات إلى التوكيلات ومراكز الصيانة المعتمدة في الزقازيق أو العاشر من رمضان أو القاهرة."
    ],
    faqs: [
      {
        "q": "كم يستغرق وصول ونش الإنقاذ في أبو حماد؟",
        "a": "يصل الونش خلال 15-25 دقيقة داخل مدينة أبو حماد وعلى طريق الزقازيق - الإسماعيلية الزراعي."
      },
      {
        "q": "هل تخدمون قرى ومركز أبو حماد مثل العباسة وكفر العزازي؟",
        "a": "نعم، نغطي مركز أبو حماد بالكامل بما في ذلك العباسة، كفر العزازي، الصوة، والقطاوية على مدار 24 ساعة."
      },
      {
        "q": "هل يمكن نقل السيارة من أبو حماد إلى التوكيل بالزقازيق أو العاشر من رمضان؟",
        "a": "بالتأكيد، نوفر خدمة نقل آمن بالسطحة الهيدروليكية لأي مركز صيانة أو توكيل تختاره في الزقازيق أو العاشر من رمضان أو القاهرة بخصم 50%."
      }
    ],
    nearby: ["الزقازيق", "التل الكبير", "بلبيس", "العاشر من رمضان", "الإسماعيلية", "الشرقية"]
  },

  "طريق السخنة": {
    tier: 1,
    title: "ونش انقاذ طريق العين السخنة",
    metaDescription: "ونش انقاذ طريق السخنة السريع 24 ساعة. إنقاذ سيارات وحوادث على مدار الطريق من الكارتة وحتى بورتو السخنة. استجابة فورية وأمان تام - 01044844492.",
    intro: "طريق العين السخنة من أكتر الطرق السريعة اللي بتحتاج تركيز، والسرعات العالية فيه بتخلي أي عطل مفاجئ يمثل خطر حقيقي على الركاب. احنا مقدرين خطورة الموقف، عشان كده أوناش إنقاذ محمد بحر متوزعة على طريق السخنة بداية من كارتة القاهرة، مروراً بمحطات البنزين، ولحد بورتو السخنة والزعفرانة. لو الكاوتش ضرب أو الموتور سخن، اقف يمين واتصل بينا فوراً.",
    responseTime: "20-30 دقيقة حسب الكيلومتر على الطريق",
    landmarks: ["كارتة القاهرة", "بوابات طريق السخنة", "محطات وطنية وماستر", "بورتو السخنة", "الجلالة"],
    streets: ["طريق القاهرة العين السخنة", "محور الجلالة", "طريق القطامية السخنة"],
    localNotes: [
      "بننصح دايماً العميل بالوقوف في أقصى اليمين وتشغيل الانتظار لحين وصول الونش المجهز بإشارات تحذيرية ضوئية لسلامة الطريق.",
      "تغطية كاملة للحوادث الكبيرة والصغيرة بالتنسيق مع المرور إذا لزم الأمر.",
      "خدمة نقل السيارات من السخنة للقاهرة أو العكس بأفضل أسعار."
    ],
    nearby: ["العين السخنة", "بورتو السخنة", "القطامية", "المعادي"],
    faqs: [
      {
        "q": "أنا عطلت على طريق السخنة ومش عارف مكاني بالظبط، أعمل إيه؟",
        "a": "مفيش مشكلة، ابعتلنا اللوكيشن (الموقع) على الواتساب على نفس الرقم 01044844492 والونش هيوصلك لحد مكانك بالـ GPS."
      },
      {
        "q": "بتاخدوا وقت أد إيه عشان توصلوا بعد الكارتة بـ 50 كيلو؟",
        "a": "متوسط الوصول بيكون 30 دقيقة لأن أوناشنا بتتحرك من نقاط ارتكاز على الطريق نفسه مش من جوه القاهرة."
      }
    ]
  },

  "محور المشير": {
    tier: 1,
    title: "ونش انقاذ محور المشير",
    metaDescription: "عطلت على محور المشير طنطاوي؟ ونش انقاذ سريع متواجد 24/7 لرفع سيارتك من الطريق السريع وتجنب المخالفات. اتصل بنا الآن 01044844492.",
    intro: "محور المشير طنطاوي شريان حيوي بيربط بين التجمع ومدينة نصر، والوقوف عليه بسبب عطل بيعرضك للخطر وممكن يسببلك مخالفة مرورية. عشان كده التدخل السريع هنا مش رفاهية، ده ضرورة. ونش محمد بحر متمركز في مداخل مدينة نصر والتجمع وقادر يوصلك على محور المشير في دقايق عشان يرفع العربية ويفضي الطريق بأمان وسرعة.",
    responseTime: "10-15 دقيقة على محور المشير",
    landmarks: ["مسجد المشير طنطاوي", "مركز مصر للمعارض الدولية", "كايرو فستيفال", "ستاد الدفاع الجوي"],
    streets: ["محور المشير طنطاوي", "شارع التسعين", "امتداد رمسيس", "كوبري اكتوبر (المطالع)"],
    localNotes: [
      "أولوية قصوى لبلاغات الأعطال على محور المشير لمنع التكدس والحوادث.",
      "سحب السيارات إلى أقرب توكيل في مدينة نصر أو التجمع الخامس بسلاسة."
    ],
    nearby: ["مدينة نصر", "التجمع الخامس", "القطامية", "الطريق الدائري"],
    faqs: [
      {
        "q": "العربية قطعت بنزين على محور المشير، هل ممكن تجيبولي بنزين بدل السحب؟",
        "a": "أكيد، بنقدم خدمة توصيل البنزين (دليفري وقود) عشان تدور وتمشي علطول بدل ما تدفع تكلفة ونش كاملة."
      }
    ]
  },

  "صلاح سالم": {
    tier: 1,
    title: "ونش انقاذ صلاح سالم",
    metaDescription: "ونش انقاذ طريق صلاح سالم: نفق العروبة، أرض المعارض، بانوراما حرب أكتوبر، كوبري الفردوس، وطريق المطار. وصول في 10-15 دقيقة خدمة 24 ساعة - اتصل 01044844492.",
    intro: "ونش إنقاذ طريق صلاح سالم المحوري؛ تغطية فورية من المطار والعروبة حتى نفق الأزهر والقلعة مع إخلاء سريع للسيارات خلال 5 إلى 10 دقائق لتفادي سد نهر الشارع.",
    responseTime: "5–10 دقائق في صلاح سالم",
    landmarks: ["بانوراما حرب أكتوبر", "نفق العروبة", "الجهاز المركزي للمحاسبات", "أرض المعارض الدولية", "كوبري الفردوس", "مطار القاهرة (بداية صلاح سالم)"],
    streets: ["طريق صلاح سالم", "شارع الطيران", "امتداد رمسيس", "كوبري 6 أكتوبر", "محور النصر"],
    localNotes: ["سرعة استجابة فائقة لإخلاء مسار صلاح سالم الحيوي ومنع التكدسات المرورية وتفادي مخالفات التعطيل.", "تغطية متخصصة لمحيط نفق العروبة، نفق الأزهر، كوبري الفردوس، ومحيط دار القوات الجوية والقلعة.", "جاهزية لنقل السيارة لورش مدينة نصر أو مصر الجديدة أو وسط البلد في دقائق معدودة."],
    nearby: ["مصر الجديدة", "مدينة نصر", "العباسية", "حدائق القبة", "الأوتوستراد"],
    faqs: [
      {
            "q": "كم يستغرق ونش صلاح سالم للوصول في أوقات زحام الموظفين؟",
            "a": "يصلك الونش في غضون 8 إلى 10 دقائق لتمركز أوناشنا في فتحات ومحاور الدوران الحيوية على صلاح سالم."
      },
      {
            "q": "هل تنقذون السيارات التي تسخن داخل نفق العروبة أو نفق الأزهر؟",
            "a": "نعم، نتعامل فوراً مع أعطال الأنفاق ونسحب السيارة بأمان لخارج النفق لتفادي الاختناقات."
      }
]
  },

  "محمد بحر": {
    tier: 1,
    title: "ونش انقاذ سيارات محمد بحر",
    metaDescription: "ونش انقاذ محمد بحر - الشركة الرائدة في إنقاذ وسحب السيارات في مصر منذ 25 عاماً. أسطول ضخم، خدمة 24/7، وأسعار عادلة تناسب الجميع - 01044844492.",
    intro: "ونش إنقاذ محمد بحر مش مجرد خدمة سحب عربيات، إحنا اسم بيبني ثقة مع السواق المصري من سنين طويلة. قصة بدأت بونش واحد وبقت دلوقتي أسطول ضخم بيغطي القاهرة الكبرى وكل طرق السفر والمحافظات. شعارنا دايماً الأمان، السرعة، والسعر العادل اللي مابنستغلش فيه أزمة العميل. لو عطلت في أي مكان في مصر، محمد بحر هو ظهرك اللي بتسند عليه.",
    responseTime: "وصول فوري من أقرب نقطة تمركز لك (10-20 دقيقة داخل القاهرة)",
    landmarks: ["تغطية جميع المحافظات", "تغطية كافة الطرق السريعة", "تغطية القاهرة الكبرى"],
    streets: ["خدمة على مستوى الجمهورية", "الطريق الدائري", "طريق السويس", "طريق السخنة", "الصحراوي"],
    localNotes: [
      "مؤسسة محمد بحر تمتلك أحدث أسطول من أوناش السطحة (فلات بيد) الهيدروليكية.",
      "فريق السائقين مدرب على أعلى مستوى للتعامل مع كافة الأعطال وحوادث الطرق المعقدة.",
      "خدمة عملاء تعمل 24 ساعة لاستقبال بلاغات الأعطال عبر الهاتف والواتساب."
    ],
    nearby: ["جميع مناطق القاهرة", "الجيزة", "القليوبية", "الإسكندرية", "طرق السفر"],
    faqs: [
      {
        "q": "ليه أختار ونش محمد بحر تحديداً؟",
        "a": "لأننا بنوفرلك أسرع استجابة من خلال أقرب ونش لموقعك، أسعارنا واضحة ومفيهاش استغلال (خصم 50%)، وبنضمنلك أمان عربيتك 100%."
      },
      {
        "q": "هل أوناش محمد بحر بتنقل سيارات الحوادث المدمرة كلياً؟",
        "a": "نعم، نمتلك أوناش مزودة برافعات هيدروليكية عملاقة لانتشال السيارات من المنحدرات أو بعد الحوادث الصعبة وتأمينها."
      }
    ]
  }
};
